import {
  Link as MuiLink,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Capacitor } from '@capacitor/core';

const SLACK_TEAM_ID = 'T025E476A3A';

// Reference:
// - Web: https://api.slack.com/reference/deep-linking#app_channel
// - Native: https://api.slack.com/reference/deep-linking#open_a_channel
const getSlackChannelDeepLink = (channelId: string): string =>
  Capacitor.isNativePlatform()
    ? `slack://channel?team=${SLACK_TEAM_ID}&id=${channelId}`
    : `https://slack.com/app_redirect?team=${SLACK_TEAM_ID}&channel=${channelId}`;

type SlackChannelDeepLinkProps = {
  label: string;
  channelId?: string | null;
  channelName?: string;
};

export const SlackChannelDeepLink = (
  props: SlackChannelDeepLinkProps,
): JSX.Element | undefined => {
  const { label, channelId, channelName } = props;

  if (!channelId || !channelName) {
    return undefined;
  }

  return (
    <ListItemButton
      divider
      component={MuiLink}
      href={getSlackChannelDeepLink(channelId)}
      target="_blank"
    >
      <ListItemText
        primary={
          <>
            <Typography color="secondary" component="span" variant="h4">
              {label}
            </Typography>
            <Typography
              sx={{
                color: 'accent.main',
                fontWeight: 'fontWeightMedium',
                textDecoration: 'underline',
              }}
            >{`#${channelName}`}</Typography>
          </>
        }
      />
      <OpenInNewIcon />
    </ListItemButton>
  );
};
